module.exports = __webpack_public_path__ + "img/image-png.f139d3b8.png";